/**
 * Created by calhosh on 4/14/2017.
 */

import * as english from './en-us';
import * as japanese from './ja-jp';
import * as frenchCanadian from './fr-ca';
import * as spanish from './es';
import * as portuguese from './pt-br';
import * as chineseSimplified from './zh-cn';
import * as chineseTraditional from './zh-tw';
import * as hebrew from './he';
import * as korean from './ko';
import * as russian from './ru';

const languages = {
	'en-us': english,
	ja: japanese,
	'fr-ca': frenchCanadian,
	es: spanish,
	'pt-br': portuguese,
	'zh-cn': chineseSimplified,
	'zh-tw': chineseTraditional,
	he: hebrew,
	ko: korean,
	ru: russian,
};

export default function(locale) {
	return Object.assign({}, languages['en-us'], languages[locale]);
}
